import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { map, Observable, shareReplay } from 'rxjs';

@Injectable()
export class ScreenSizeService {
  constructor(private breakpointObserver: BreakpointObserver) {}

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe([Breakpoints.Handset])
    .pipe(
      map((result) => result.matches),
      shareReplay({ refCount: true, bufferSize: 1 })
    );

  isHandsetLandscape$: Observable<boolean> = this.breakpointObserver
    .observe([Breakpoints.HandsetLandscape])
    .pipe(
      map((result) => result.matches),
      shareReplay({ refCount: true, bufferSize: 1 })
    );
}
